// Palette TargPatrol
export default {
  gray900: '#101828',
  gray700: '#344054',
  gray600: '#475467',
  gray500: '#667085',
  gray400: '#98A2B3',
  gray300: '#D0D5DD',
  gray200: '#EAECF0',
  gray100: '#F2F4F7',
  gray050: '#F9FAFB',
  primary900: '#004F7A',
  primary800: '#065986',
  primary700: '#026AA2',
  primary600: '#0086C9',
  primary500: '#0BA5EC',
  primary400: '#36BFFA',
  primary300: '#35B2EB',
  primary200: '#B9E6FE',
  primary100: '#E0F2FE',
  primary: '#41BEF6',
  error500: '#F04438',
};
